export async function setupSuperCoupon() {
  const params = new URLSearchParams(window.location.search);
  const vendorLogoDiv = document.getElementById('vendor-logo') as HTMLDivElement;
  const labelEl = document.getElementById('label') as HTMLSpanElement;
  const descriptionEl = document.getElementById('description') as HTMLSpanElement;
  const vendorNameEl = document.getElementById('vendor-name') as HTMLElement;
  const addressEl = document.getElementById('address') as HTMLAnchorElement;
  const confirmationDialog = document.getElementById('confirmation') as HTMLDialogElement;
  const slider = document.getElementById('slider') as HTMLElement & { reset: () => void };

  const hex = params.get('id');
  const vendorId = params.get('vendor_id')!;
  vendorLogoDiv.outerHTML = `<a href='/gift-form?vendor_id=${vendorId}' target='_blank'><img id="vendor-logo" class="logo" src="images/${vendorId}-logo.png" /></a>`;
  if (!hex || !vendorId || hex === 'null' || vendorId === 'null') return;
  fetchSuperCoupon(hex, vendorId).then((response) => {
    const vendorName = response.vendorName;
    vendorNameEl.innerHTML = vendorName;
    labelEl.innerHTML = response.label;
    if (response.description) {
      descriptionEl.innerHTML = response.description;
    } else {
      descriptionEl.outerHTML = '';
    }
    addressEl.href = `/locations?vendor_id=${vendorId}`;
    if (response.served) {
      window.location.href = `/super-enjoy?id=${hex}&vendor_id=${vendorId}`;
    }
    confirmationDialog.addEventListener('close', () => slider.reset());
    confirmationDialog.querySelector('.cancel')!.addEventListener('click', () => confirmationDialog.close());
    confirmationDialog.querySelector('.confirm')!.addEventListener('click', () => {
      confirmationDialog.close();
      showSuperRedeemingPassphrase(hex, vendorId, response.label, response.description);
    });
    slider.addEventListener('unlocked', () => confirmationDialog.showModal());
  });
}

export async function setupSuperEnjoy() {
  const hex = new URLSearchParams(window.location.search).get('id');
  const vendorId = new URLSearchParams(window.location.search).get('vendor_id');
  const mascotEl = document.getElementById('mascot') as HTMLDivElement;
  const descriptionEl = document.getElementById('description') as HTMLSpanElement;
  const labelEl = document.getElementById('label') as HTMLSpanElement;
  const vendorLogoDiv = document.getElementById('vendor-logo') as HTMLDivElement;

  if (!hex || !vendorId) return;
  const { label, description } = await fetchSuperCoupon(hex, vendorId);

  const sendCoffeeBtn = document.getElementById('gift-back') as HTMLButtonElement;
  const exploreBtn = document.getElementById('explore') as HTMLButtonElement;
  sendCoffeeBtn.onclick = () => window.location.assign(`/gift-form?vendor_id=${vendorId}`);
  exploreBtn.onclick = () => window.location.replace(`https://www.sipps.no`);

  mascotEl.outerHTML = `<img class='mascot' src='images/mascot-with-cup.png' />`;
  labelEl.innerHTML = label;
  vendorLogoDiv.outerHTML = `<a href='/gift-form?vendor_id=${vendorId}' target='_blank'><img id="vendor-logo" class="logo" src="images/${vendorId}-logo.png" /></a>`;

  if (description) {
    descriptionEl.innerHTML = description;
  } else {
    descriptionEl.outerHTML = '';
  }
}

export async function fetchSuperCouponNoVendor(hex: string) {
  const response = await fetch(`/api/coupon/super/${hex}`);
  if (!response.ok) throw new Error('Failed to fetch coupon');
  return await response.json();
}

export async function fetchSuperCoupon(hex: string, vendorId: string) {
  const response = await fetch(`/api/coupon/super/${hex}/${vendorId}`);
  if (!response.ok) throw new Error('Failed to fetch coupon');
  return await response.json();
}

export async function fetchSuperPassphrase(hex: string, vendorId: string) {
  const response = await fetch(`/api/coupon/super/${hex}/${vendorId}/passphrase`);
  if (!response.ok) throw new Error('Failed to fetch passphrase');
  return await response.json();
}

export async function showSuperRedeemingPassphrase(hex: string, vendorId: string, label: string, description: string) {
  const json = await fetchSuperPassphrase(hex, vendorId);

  const overlay = document.createElement('div');
  overlay.style.position = 'fixed';
  overlay.style.top = '0';
  overlay.style.left = '0';
  overlay.style.width = '100vw';
  overlay.style.height = '100vh';
  overlay.style.background = 'rgba(0, 0, 0, 0.8)';
  overlay.style.color = 'white';
  overlay.style.display = 'flex';
  overlay.style.flexDirection = 'column';
  overlay.style.alignItems = 'center';
  overlay.style.justifyContent = 'center';
  overlay.style.fontSize = '1.5rem';
  overlay.style.zIndex = '9999';
  overlay.style.padding = '2rem';
  overlay.style.boxSizing = 'border-box';

  const message = document.createElement('div');
  message.textContent = json.passphrase;
  message.style.marginBottom = '1.5rem';
  message.style.textAlign = 'center';

  const itemDiv = document.createElement('div');
  itemDiv.textContent = `${label}: ${description}`;
  itemDiv.style.marginBottom = '1.5rem';
  itemDiv.style.textAlign = 'center';

  const progressBarContainer = document.createElement('div');
  progressBarContainer.style.width = '80%';
  progressBarContainer.style.height = '8px';
  progressBarContainer.style.background = 'rgba(255, 255, 255, 0.2)';
  progressBarContainer.style.borderRadius = '4px';
  progressBarContainer.style.overflow = 'hidden';

  const progressBar = document.createElement('div');
  progressBar.style.width = '0%';
  progressBar.style.height = '100%';
  progressBar.style.background = 'white';
  progressBar.style.transition = 'width 10s linear';

  // Assemble DOM
  progressBarContainer.appendChild(progressBar);
  overlay.appendChild(message);
  overlay.appendChild(itemDiv);
  overlay.appendChild(progressBarContainer);
  document.body.appendChild(overlay);

  // Start animation
  requestAnimationFrame(() => {
    progressBar.style.width = '100%';
  });

  setTimeout(() => {
    overlay.remove();
    window.location.href = `/super-enjoy?id=${hex}&vendor_id=${vendorId}`;
  }, 10000);
}
